import { IDFA } from "@lib/idfa";
import formatISO from "date-fns/formatISO";
import isAfter from "date-fns/isAfter";
import subDays from "date-fns/subDays";
import { Platform } from "react-native";
import deviceInfoModule from "react-native-device-info";
import Share from "react-native-share";
import { call, put, select } from "redux-saga/effects";
import { postApplinkCustomEvent } from "@lib/applinks/api";
import { APP_VISIBILITY_EVENT } from "@lib/applinks/analyticsConstants";
import { actions as configActions } from "@reducers/configReducer";
import appList from "./appList";

const userIdSelector = (state) => state.auth?.user?.user_id;
const appVisibilitySyncedTimestamp = (state) =>
  state?.configReducer?.appVisibilityConfig?.syncedTimestamp;

function* trackVisibleApps() {
  try {
    if (yield call(deviceInfoModule.isEmulator) || Platform.OS === "ios") {
      return;
    }
    const syncedTimeStamp = yield select(appVisibilitySyncedTimestamp);
    const userId = yield select(userIdSelector);
    const timeBreached =
      !syncedTimeStamp ||
      (typeof syncedTimeStamp === "number" &&
        isAfter(
          subDays(new Date(), 1),
          new Date(parseInt(syncedTimeStamp, 10)),
        ));

    if (userId && timeBreached) {
      const apps = Object.values(
        Object.keys(appList).reduce(
          (acc, curr) => ({ ...acc, ...appList[curr] }),
          {},
        ),
      );

      const payload = {};
      for (let i = 0; i < apps.length; i++) {
        const { isInstalled } = yield call(Share.isPackageInstalled, apps[i]);
        payload[apps[i]] = isInstalled;
      }
      const userData = {
        idfa: yield call(IDFA.getIDFA),
        deviceid: deviceInfoModule.getDeviceId(),
      };

      yield call(postApplinkCustomEvent, APP_VISIBILITY_EVENT, {
        user_id: userId,
        user_data: userData,
        last_attributed_touch_data: {
          app_list: payload,
          fetched_at: formatISO(+new Date()),
        },
      });

      yield put(configActions.updateAppVisibilitySyncTimestamp(+new Date()));
    }
  } catch (e) {
    console.log(e);
  }
}

export default trackVisibleApps;
